module.exports = __webpack_public_path__ + "img/novelgie.ef76cc34.png";